import pixelWidth from 'string-pixel-width'
import specialHeaders from '../../resource/specialHeaders.json'

export let extendedHeader = []

function generateInitialHeaders(objectToReadPropertiesFrom) {
  return Object.keys(objectToReadPropertiesFrom).map(columnObjectKey => {
    var columnName = ''
    if (specialHeaders.headers.hasOwnProperty(columnObjectKey)) {
      columnName = specialHeaders.headers[columnObjectKey].columnName
    } else {
      var result = columnObjectKey.replace(/([A-Z])/g, ' $1')
      columnName = result.charAt(0).toUpperCase() + result.slice(1)
    }

    const columnNameWidth = pixelWidth(columnName, { size: 15 })
    const columnContentWidth = pixelWidth(
      String(objectToReadPropertiesFrom[columnObjectKey]),
      { size: 15 }
    )
    return {
      text: columnName,
      value: columnObjectKey,
      sortable: true,
      width:
        Number(columnNameWidth) > Number(columnContentWidth) ||
        columnName == 'Link'
          ? columnNameWidth
          : columnContentWidth
    }
  })
}

function generateHeaderOverrides(headers, headerOverrides) {
  return headers.map(header => {
    if (
      headerOverrides
        .map(override => override.propertyToOverride)
        .includes(header.value)
    ) {
      const headerOverride = headerOverrides.find(
        x => x.propertyToOverride == header.value
      ).propertyNewName
      header.text = headerOverride
    }
    return header
  })
}

function removeUnnecessaryHeaders(headers, headersToExclude) {
  return (headers = headers.filter(header => {
    return !headersToExclude.includes(header.value)
  }))
}

export function generateTableHeaders(
  object,
  headerOverrides,
  headersToExclude
) {
  let headers = generateInitialHeaders(object)
  if (headerOverrides.length) {
    headers = generateHeaderOverrides(headers, headerOverrides)
  }

  if (headersToExclude.length) {
    headers = removeUnnecessaryHeaders(headers, headersToExclude)
  }

  return headers
}
